var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCrown = function SvgCrown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 13,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FBB33E",
    d: "M15.058 10.397H.971v1.248c0 .593.48 1.074 1.074 1.074h11.939c.593 0 1.074-.48 1.074-1.074z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD647",
    d: "m.003 2.497.904 6.665h14.186l.904-6.665a.269.269 0 0 0-.418-.257l-3.728 2.555a.27.27 0 0 1-.369-.063L8.192.293a.27.27 0 0 0-.432.002L4.518 4.732a.27.27 0 0 1-.369.063L.421 2.24a.269.269 0 0 0-.418.257"
  })));
};
export default SvgCrown;